import React, { useState } from 'react';
import { Toolbar, Stack, Button, IconButton, Paper } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { exportToExcel } from "react-json-to-excel";
import { useCanView } from "../../../config/hook/UserPermissions";
import Alert from "../../../components/form/Alert";
import get from "lodash/get";

const ToolbarComponent = ({ __, reload, data }) => {
    const navigate = useNavigate();
    const canView = useCanView();
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const closeAlert = () => setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" className='w-full'>
                <Button
                    className='w-[100px] min-w-[100px]'
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        // if (canView("TRANSACCIONES/INVOICES", "add")) {
                            navigate("new");
                        // } else {
                        //     setAlert({
                        //         open: true,
                        //         title: "Permiso Denegado.",
                        //         subtitle: (<ul> • No tienes permiso para crear invoices.</ul>),
                        //         type: "error",
                        //         btn: "Cerrar",
                        //         func: closeAlert
                        //     });
                        // }
                    }}
                >
                    {__(`toolbar.btn`)}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<SaveAltIcon />}
                    onClick={() => exportToExcel(data || [], 'Invoices')}
                    disabled={!data || data.length === 0}
                >
                    Exportar
                </Button>
                <IconButton title={__(`toolbar.reload`)} onClick={reload}>
                    <ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} />
                </IconButton>
            </Stack>
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Toolbar>
    );
};

export default ToolbarComponent;
